/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './procedure-consumable.reducer';

export const ProcedureConsumableDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const procedureConsumableEntity = useAppSelector(state => state.procedureConsumable.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="procedureConsumableDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.procedureConsumable.detail.title">ProcedureConsumable</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.procedureConsumable.id">Id</Translate>
            </span>
          </dt>
          <dd>{procedureConsumableEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.procedureConsumable.active">Active</Translate>
            </span>
          </dt>
          <dd>{procedureConsumableEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.procedureConsumable.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{procedureConsumableEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.procedureConsumable.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{procedureConsumableEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.procedureConsumable.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{procedureConsumableEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.procedureConsumable.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{procedureConsumableEntity.timestampentry}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.procedureConsumable.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{procedureConsumableEntity.quantity}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureConsumable.consumable">Consumable</Translate>
          </dt>
          <dd>{procedureConsumableEntity.consumable ? procedureConsumableEntity.consumable.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureConsumable.procedure">Procedure</Translate>
          </dt>
          <dd>{procedureConsumableEntity.procedure ? procedureConsumableEntity.procedure.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/procedure-consumable" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/procedure-consumable/${procedureConsumableEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProcedureConsumableDetail;
